var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconExplorer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60.372,
    height: 60.372,
    viewBox: "0 0 60.372 60.372",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6469",
    "data-name": "Group 6469",
    transform: "translate(-155.663 -613.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(142.163 600.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6464",
    "data-name": "Group 6464",
    transform: "translate(16 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11701",
    "data-name": "Path 11701",
    d: "M70.336,70.336,57.507,57.484m7.11-17.176A24.308,24.308,0,1,1,40.308,16,24.308,24.308,0,0,1,64.617,40.308Z",
    transform: "translate(-16 -16)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 5
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_209",
    "data-name": "Line 209",
    x2: 15,
    transform: "translate(175.5 634.5)",
    fill: "none",
    stroke: "#f69139",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 5.759,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_211",
    "data-name": "Line 211",
    x2: 15,
    transform: "translate(175.5 648.145)",
    fill: "none",
    stroke: "#f69139",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 5.759,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_210",
    "data-name": "Line 210",
    x2: 18,
    transform: "translate(172.5 641.322)",
    fill: "none",
    stroke: "#f69139",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 5.759,
    strokeWidth: 4
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconExplorer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-explorer.7543fe80.svg";
export { ForwardRef as ReactComponent };